import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_0 = ({ skinColours, lipColours }) => {
  const colour0 = skinColours.shadow;
  const colour1 = lipColours.shadow;
  const colour2 = lipColours.shadow;
  const colour3 = lipColours.base;
  const colour4 = '#4A3837';
  const colour5 = '#3E2F2C';
  const colour6 = '#342723';
  const colour7 = '#231A18';
  const colour8 = '#DC3634';
  const colour9 = '#F58981';
  const colour10 = '#F26767';
  const colour11 = '#EC4845';
  const colour12 = '#FFFEF0';
  const colour13 = '#FFE9CF';
  const colour14 = '#F2D5B2';
  const colour15 = '#F8A798';
  const colour16 = lipColours.shadow;

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M372.1,708l8.1-4.2c0,0,20.7,8,34.5,4.6c4.8-1.2,13.6-6.2,13.6-6.2l-3.1,4.7c0,0-4.5,1.2-9.9,2.5
		c-9.1,2.2-20.7,4.8-25.9,3.9C383.5,712.2,372.1,708,372.1,708z"
        />
        <path
          fill={colour1}
          d="M329,618.6c-1,7.4,19.8,58.4,23.6,61.2c2.3,1.7,20.3,19.2,45.9,19.8c22.3,0.5,36.7-8.7,52.8-21.8
		c4.2-3.4,18.9-46.7,21-57.8c3.9-21.1-9.3-52.5-22.9-74c-3.8-4.5-49.5-29.3-97.2,4.5C352.2,550.5,330.9,604.5,329,618.6z"
        />
        <path
          fill={colour2}
          d="M414.2,656.4c-36.2,0-67.5-19.6-82.7-48.1c-1.3,4.3-2.2,8-2.5,10.4c-1,7.4,19.8,58.4,23.6,61.2
		c2.3,1.7,20.3,19.2,45.9,19.8c22.3,0.5,36.7-8.7,52.8-21.8c2.7-2.2,9.6-20.5,14.8-36.4C451.3,650.8,433.4,656.4,414.2,656.4z"
        />
        <path
          fill={colour3}
          d="M331.4,617.3c-0.6,8,17.4,56,21.1,59c2.3,1.8,20.3,20.2,45.9,20.9c15.5,0.4,34.2-9.1,52.8-23.1
		c4.5-3.3,17-46.1,19.1-58c3.9-22.6-7.4-63.7-21-86.8c-3.8-4.8-49.2-32.8-96.8,3.6C352.5,532.8,334.8,575.1,331.4,617.3z"
        />
        <path
          fill={colour2}
          d="M333.4,618.2c-0.6,7.3,18.7,47.1,22.3,49.8c2.2,1.7,19.2,14.1,43.4,14.7c14.7,0.4,32.4-3.8,50.1-16.7
		c4.2-3.1,16.5-41.7,18.5-52.7c3.7-20.9-7.9-56.4-20.8-77.7c-3.6-4.4-46.9-29.1-92,4.4C354.8,540.1,336.7,579.2,333.4,618.2z"
        />
        <path
          fill={colour4}
          d="M333.4,618.2c-0.6,6.9,17.1,45.4,20.6,48c2.2,1.6,21.5,13,45.7,13.6c14.7,0.3,34.8-4.5,49.9-16.2
		c4-3.1,16.4-38.2,18.3-48.7c3.5-19-7.4-53.1-19.7-73.6c-1.3-2.1-3-3.9-5.1-5.1c-11.1-6.5-44.7-18.8-80.8,2.1
		c-4.8,2.8-8.5,7-10.6,12.1C346.3,563.3,335.8,591.1,333.4,618.2z"
        />
        <path
          fill={colour5}
          d="M340.9,620.1c-0.5,6.3,15.3,40.9,18.5,43.3c2,1.5,19.3,11.7,40.9,12.3c13.1,0.3,31.2-4,44.7-14.6
		c3.6-2.8,14.7-34.4,16.4-43.8c3.2-17.1-6.6-47.8-17.6-66.3c-1.1-1.9-2.7-3.5-4.6-4.6c-9.9-5.9-40.1-17-72.4,1.9
		c-4.3,2.5-7.6,6.3-9.5,10.9C352.4,570.6,343,595.7,340.9,620.1z"
        />
        <path
          fill={colour6}
          d="M348.9,627.9c-0.5,5.4,13.2,35,15.9,37c1.7,1.2,16.6,10,35.2,10.5c11.3,0.3,26.8-3.4,38.5-12.5
		c3.1-2.4,12.6-29.5,14.1-37.5c2.7-14.6-5.7-40.9-15.2-56.8c-1-1.6-2.3-3-4-3.9c-8.6-5-34.5-14.5-62.3,1.6c-3.7,2.1-6.6,5.4-8.2,9.3
		C358.8,585.5,350.7,607,348.9,627.9z"
        />
        <path
          fill={colour7}
          d="M368.1,626.4c-0.3,3.4,8.4,22.2,10.1,23.5c1.1,0.8,10.5,6.4,22.3,6.7c7.2,0.2,17-2.2,24.4-7.9
		c2-1.5,8-18.7,8.9-23.8c1.7-9.3-3.6-26-9.6-36c-0.6-1-1.5-1.9-2.5-2.5c-5.4-3.2-21.9-9.2-39.5,1c-2.3,1.4-4.2,3.4-5.2,5.9
		C374.4,599.6,369.3,613.2,368.1,626.4z"
        />
        <path
          fill={colour8}
          d="M446.8,662.1c2.6-1.8,8.4-16.7,13-29.4c-6.8-8.9-13.6-12.6-23-14.4c-26-4.9-36.8,7.4-36.8,7.4
		s-9.5-10.7-28-8.5c-10.9,1.3-27,8.5-28.8,22.6c5.3,11.2,11.7,22.8,13.6,24.1c2.1,1.6,19,12.5,42.3,13.1
		C413.3,677.4,429.8,673.9,446.8,662.1z"
        />
        <path
          fill={colour9}
          d="M349.5,631.5c-1.8,1.8-2.3,4.5-1.2,6.8c4.2,8.8,17.4,29.7,49.1,29.9c38.4,0.2,51.1-11.8,58.2-34.5
		c0.7-2.1-0.1-4.4-1.8-5.8c-9.7-7.7-36.3-13.3-53.7-2.8C385.5,615.3,363.2,618.3,349.5,631.5z"
        />
        <g>
          <path
            fill={colour10}
            d="M425.8,619.5c-8.9-0.4-18.3,1.1-25.9,5.7c-9.8-6.7-23.2-7.5-35.1-3.2c2.4-0.5,5-0.9,7.7-1.1
			c13.6-0.9,22.2,4.1,25.4,9.3c0.6,1,1.1,1.9,1.5,2.8C401.4,627,412.7,621,425.8,619.5z"
          />
          <path
            fill={colour10}
            d="M455.3,630.2c-2.1,31.8-105.6,21.1-106.7,3.3c0-0.3,0-0.6,0-0.9c-1.1,1.7-1.3,3.9-0.4,5.8
			c4.2,8.8,17.4,29.7,49.1,29.9c38.4,0.2,51.1-11.8,58.2-34.5C455.8,632.6,455.8,631.3,455.3,630.2z"
          />
        </g>
        <path
          fill={colour11}
          d="M400.9,653.1c-19.4,0-36.4-4.6-49.4-9c6.3,10,19.7,24.1,45.8,24.2c32.4,0.2,46.8-8.3,54.7-24.6
		C440.1,649.6,420.5,653.1,400.9,653.1z"
        />
        <path
          fill={colour12}
          d="M359,558.7c-1.4,0.4-2.9,0-4-1.1c-1-1.1-1.3-2.6-0.9-4l1-2.9c1.5-4.3,4.7-7.7,8.8-9.6
		c25.6-11.4,43.7-15,72.4-4.4c5.7,2.1,10.2,6.6,12.3,12.2l2.5,6.6c0.4,1.2,0.2,2.5-0.7,3.4c-0.9,0.9-2.2,1.3-3.4,0.9
		C413.8,549.2,390.3,550.2,359,558.7z"
        />
        <path
          fill={colour13}
          d="M451.3,555.5l-2.5-6.6c-0.4-1-0.9-2-1.4-2.9c0.1,0.2,0.1,0.3,0.2,0.5l2.4,6.6c0.4,1.2,0.2,2.5-0.7,3.4
		c-0.8,0.9-2.1,1.3-3.2,0.9c-31.8-10.6-54.2-9.6-84-1.1c-1.4,0.4-2.8,0-3.8-1.1c-1-1.1-1.3-2.6-0.8-4l1-2.9c0.8-2.3,2-4.4,3.6-6.1
		c-3.1,2-5.6,5-6.8,8.5l-1,2.9c-0.5,1.4-0.2,2.9,0.9,4c1,1.1,2.5,1.5,4,1.1c31.3-8.5,54.7-9.4,88.1,1.1c1.2,0.4,2.5,0,3.4-0.9
		C451.4,558,451.7,556.6,451.3,555.5z"
        />
        <path
          fill={colour14}
          d="M402.3,538.3c19.3,0,36.3,4.2,46.4,10.5c-2.2-5.6-6.6-10.1-12.3-12.2c-28.7-10.6-46.8-7.1-72.4,4.4
		c-3.5,1.6-6.4,4.3-8,7.8C366.2,542.5,383.1,538.3,402.3,538.3z"
        />
        <path
          fill={colour12}
          d="M345.5,646.3c4.5,9,9.2,17.1,10.8,18.2c2.2,1.6,19.3,12.7,42.9,13.2c14.3,0.3,31.1-3.2,48.3-15.1
		c1.7-1.2,4.8-7.9,8-15.9C413.6,659.3,384.4,658.9,345.5,646.3z"
        />
        <path
          fill={colour13}
          d="M454.6,648.7c0.3-0.7,0.5-1.3,0.8-2c-41.8,12.6-71,12.2-109.9-0.4c0.3,0.7,0.7,1.3,1,1.9
		C384.7,660.5,413.7,660.9,454.6,648.7z"
        />
        <path
          fill={colour14}
          d="M447.7,656.7c-17.3,11.9-34.2,15.5-48.6,15.1c-23.8-0.6-41-11.6-43.2-13.2c-1.2-0.8-4-5.4-7.3-11.4
		c-1.1-0.3-2.1-0.7-3.2-1c4.5,9,9.2,17.1,10.8,18.2c2.2,1.6,19.3,12.7,42.9,13.2c14.3,0.3,31.1-3.2,48.3-15.1
		c1.7-1.2,4.8-7.9,8-15.9c-0.8,0.2-1.6,0.5-2.3,0.7C450.9,652.3,449,655.9,447.7,656.7z"
        />
        <path
          fill={colour0}
          d="M474.9,591.5c0.8,2.6,2.6,4.7,2.9,12.6c0.3,6.4-0.6,17.7-1.9,27c0,0,5.5-18.1,4.6-30.6
		C480,593.9,474.9,591.5,474.9,591.5z"
        />
        <path
          fill={colour0}
          d="M326,637.2c-0.7-2.8-3-14.4-2.6-23.4c0.2-6,2.5-8,4.2-16.2c0,0-8.2,5.9-7.1,18.4
		C321.4,625.9,326,637.2,326,637.2z"
        />
        <path
          fill={colour6}
          d="M389.8,583.3c6.7-2.4,9.2,2.7,9.2,3.5c0,0.8-5.8,8.8-0.3,11.3c5.5,2.5,7.1-4.6,5.5-9c-1.6-4.4,2.9-6.5,6.6-6.3
		c0,0-3-6-12.9-3.9C387.9,581,389.8,583.3,389.8,583.3z"
        />
        <polygon
          fill={colour14}
          points="403.4,533.6 404.6,543.5 406.1,532.7 	"
        />
        <polygon
          fill={colour14}
          points="381.2,536.3 382.1,543.9 383.2,535.7 	"
        />
        <polygon fill={colour13} points="437.7,555.2 437.4,548.4 435.7,556 	" />
        <polygon fill={colour5} points="406,553.8 405.1,549.1 403.2,553.9 	" />
        <path
          fill={colour11}
          d="M394.6,654.8c0,0,3.8,0.7,4.1,5.4c0,0,0.4-4.4,2.9-5.2C401.6,655.1,398.5,653,394.6,654.8z"
        />
        <path
          fill={colour11}
          d="M357.5,649.2c0,0,2.3,1,3.6,4.3c0,0,0.5-2.8,3.3-2.8C364.3,650.7,362,648.8,357.5,649.2z"
        />
        <polygon
          fill={colour14}
          points="438.9,665.5 438.1,658.1 441.1,664.4 	"
        />
        <polygon
          fill={colour14}
          points="398.4,674.4 399.1,665.7 400.7,673.8 	"
        />
        <path
          fill={colour15}
          d="M432,643.4c0.9-2.5-24.3-4.5-25.3,0.7c-0.3,1.7,6.3,4.7,13,4.5C423.3,648.5,430.9,646.6,432,643.4z"
        />
        <path
          fill={colour15}
          d="M404.5,642.1c0.3-0.9-4.2-3.7-4.8-1.7c-0.2,0.7,0.8,2.3,2.1,2.8C402.5,643.5,404.1,643.3,404.5,642.1z"
        />
        <path
          fill={colour15}
          d="M391.6,642.6c-4.6-0.9-13.8,2.6-13,3.6c1.5,1.8,25.5,4,27.7,2.1C407.2,647.4,403.6,644.9,391.6,642.6z"
        />
        <path
          fill={colour16}
          d="M412.2,691.7c-2-1.2-6.8-2-11.5-1.8c-5.2,0.2-9.8,1.6-9.6,3.2c0.2,2.2,7.6,3.6,15,2.7
		C412.5,695.2,414.6,693.2,412.2,691.7z"
        />
        <path
          fill={colour16}
          d="M422.4,688c-0.9-0.6-2.7-0.7-4.2-0.2c-1.7,0.5-2.9,1.6-2.4,2.6c0.6,1.3,3.3,1.6,5.6,0.6
		C423.3,690.1,423.5,688.7,422.4,688z"
        />
        <path
          fill={colour10}
          d="M427.9,622.6c0-0.7-1.6-1.2-3.6-1.2c-2,0-3.6,0.5-3.6,1.2s1.6,1.2,3.6,1.2
		C426.3,623.8,427.9,623.3,427.9,622.6z"
        />
        <path
          fill={colour10}
          d="M418.1,622.8c-0.1-0.6-1.4-0.8-2.8-0.4c-1.4,0.3-2.5,1.1-2.3,1.7c0.1,0.6,1.4,0.8,2.8,0.4
		C417.2,624.1,418.3,623.4,418.1,622.8z"
        />
        <path
          fill={colour10}
          d="M393.6,628.5c0.2-0.5-0.2-1.2-1.1-1.6c-0.8-0.4-1.7-0.3-1.9,0.2c-0.2,0.5,0.2,1.2,1.1,1.6
		C392.5,629.1,393.3,629,393.6,628.5z"
        />
        <path
          fill={colour10}
          d="M382.9,623.3c0-0.5-1.4-1.1-3.3-1.2c-1.8-0.1-3.4,0.2-3.4,0.7c0,0.5,1.4,1.1,3.3,1.2
		C381.3,624.2,382.9,623.9,382.9,623.3z"
        />
        <path
          fill={colour10}
          d="M368,623.4c0.1,0.5-0.8,1.1-2.1,1.5c-1.3,0.4-2.5,0.3-2.6-0.1c-0.1-0.5,0.8-1.1,2.2-1.5
		C366.7,622.9,367.9,623,368,623.4z"
        />
        <polygon fill={colour4} points="419.2,531.1 420.6,534.5 421.9,530.2 	" />
      </g>
    </>
  );
};

export default Mouth_0;
